import React from 'react';
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase,
  faTools,
  faUsers,
  faBookOpen,
  faTint,
} from '@fortawesome/free-solid-svg-icons';
import DashboardImage from '../images/img3.jpg'; // Update the path based on your project

const About = () => {
  return (
    <section className="about-fullpage">
      {/* Header section: text + image */}
      <div className="about-header">
        <div className="about-left">
          <h1>
            About the <span>Dashboard</span>
          </h1>
          <p>
            Welcome to the Digital Innovations for Water Secure Africa (DIWASA)
            Project Portfolio Dashboard, a comprehensive platform designed to
            address the persistent challenge of water data fragmentation across
            the African continent.
          </p>
          <p>
            This dashboard is developed by the International Water Management
            Institute (IWMI) as part of the DIWASA initiative. The DIWASA
            project aims to harness the power of Earth observation data,
            hydrologic modeling, and digital innovation to generate foundational
            water datasets, decision-support tools, and actionable insights that
            strengthen water management systems in Africa.
          </p>
          <p>Through this interactive dashboard, users can: </p>
        </div>

        <div className="about-image">
          <img src={DashboardImage} alt="Dashboard Visual" />
        </div>
      </div>

      {/* Feature Cards */}
      <div className="about-grid">
        <div className="about-card">
          <div className="about-card-icon icon-green">
            <FontAwesomeIcon icon={faDatabase} />
          </div>
          <div className="about-card-text">
            <h3>Explore Primary Datasets</h3>
            <p>
              Explore the list of Earth Observation and in situ data that serve as building blocks of water accounting.
            </p>
          </div>
        </div>

        <div className="about-card">
          <div className="about-card-icon icon-blue">
              <FontAwesomeIcon icon={faTint} />
          </div>
          <div className="about-card-text">
            <h3>Discover Water Data Products:</h3>
            <p>
              Access the list of earth observation data used and water data products produced for Africa.
            </p>
          </div>
        </div>

       

        <div className="about-card">
          <div className="about-card-icon icon-orange">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <div className="about-card-text">
            <h3>Identify Stakeholders</h3>
            <p>
             View the list of stakeholders we work with in each country/region for improving water governance through data management.
            </p>
          </div>
        </div>

        <div className="about-card">
          <div className="about-card-icon icon-navy">
            <FontAwesomeIcon icon={faBookOpen} />
          </div>
          <div className="about-card-text">
            <h3>Access Publications and References:</h3>
            <p>
             Review scientific publications, technical reports, and data documentations associated with each country and basin.
            </p>
          </div>
        </div>
        <div className="about-card">
          <div className="about-card-icon icon-yellow">
            <FontAwesomeIcon icon={faTools} />
          </div>
          <div className="about-card-text">
            <h3>Use Cases:</h3>
            <p>
             Explore more info on the country-specific use cases that demonstrate the co-design and co-development of water data tools.
            </p>
          </div>
        </div>

         <div className="about-card">
          <div className="about-card-icon icon-purple">
            <FontAwesomeIcon icon={faTools} />
          </div>
          <div className="about-card-text">
            <h3>Water Data Tools:</h3>
            <p>
              Explore the models, dashboards, and platforms developed to support sustainable water resources management.
            </p>
          </div>
        </div>
      </div>

      {/* Summary */}
      <div className="about-summary">
        <p>
          Users can interact with the map interface to explore country-specific
          or basin-level data portfolios. Each country profile provides a
          snapshot of the available data, tools, and stakeholder engagement, as
          well as any identified gaps or opportunities for future development
          and investment. By consolidating disparate water data into a single,
          accessible platform, this dashboard enables informed decision-making,
          promotes collaboration, and informs strategic investments toward a
          more water-secure Africa.
        </p>
      </div>
    </section>
  );
};

export default About;
